import commons from '@/util/commons.js';
export default {
	//读取本地的token
	seoInfo:{}
};



// WEBPACK FOOTER //
// ./src/store/asset/state.js